<template>
    <div
      ref="gameContainer"
      style="
        max-width: 480px;
        padding: 0;
        max-height: 100vh !important;
        margin: auto;
      "
    ></div>
</template>

<script>
import Phaser from "phaser";
import { mapState } from "vuex";
import router from "@/router";

export default {
  name: "ABC1",
  components: {
    //
  },
  computed: mapState({
    //
  }),
  props: [
    //
  ],
  data: () => ({
    //
  }),
  created() {
    //
  },
  mounted() {
    this.initializeGame();
  },
  methods: {
    initializeGame() {
      const config = {
        backgroundColor: 0xffffff,
        type: Phaser.AUTO,
        scale: {
          parent: this.$refs.gameContainer,
          mode: Phaser.Scale.FIT,
          autoCenter: Phaser.Scale.CENTER_BOTH,
          width: 480,
          height: 854,
        },
        scene: {
          preload: function () {
            this.load.image(
              "imgABC",
              require("@/mockups/ABC/book-1/assets/images/0 1.png")
            );
          },
          create: function () {
            this.add
              .text(240, 180, "Hamochi", {
                fontFamily: "roboto, sans-serif",
                fontSize: 22,
                color: "#000000",
              })
              .setOrigin(0.5);

            this.add
              .text(240, 230, "The Dream Maker", {
                fontFamily: "roboto, sans-serif",
                fontSize: 42,
                color: "#000000",
              })
              .setOrigin(0.5);

            this.add
              .text(240, 290, "梦想实现家", {
                fontFamily: "roboto, sans-serif",
                fontSize: 42,
                color: "#000000",
              })
              .setOrigin(0.5);

            this.add
              .text(240, 340, "By Lim Shi Jian", {
                fontFamily: "roboto, sans-serif",
                fontSize: 20,
                color: "#000000",
              })
              .setOrigin(0.5);

            this.add.image(240, 550, "imgABC").setScale(0.35);

            this.input.on("pointerdown", function () {
              router.push({
                name: "ABCScreen2",
              });
            });
          },
          update: function () {
            // Game logic here
          },
        },
      };

      this.game = new Phaser.Game(config);
    },
  },
  beforeDestroy() {
    if (this.game) {
      this.game.destroy(true);
    }
  },
};
</script>

<style scoped>
/* .mockup {
  background-color: white;
} */
</style>